import { getCustomer } from "./api";

export const customerDetailOptions = (slug: string) => ({
  queryKey: ["ops", "customers", "detail", slug] as const,
  queryFn: () => getCustomer(slug),
});
